﻿import {PlayerPrefs} from "../../Utils/Unity/PlayerPrefs";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {UIText} from "../Tools/Base/UIText";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {UISprite} from "../Tools/Base/UISprite";

export class UIGDPR extends UICommonPopup {
    get shown() {
        return PlayerPrefs.GetInt("gdpr", 0) == 1;
    }

    set shown(value) {
        PlayerPrefs.SetInt("gdpr", ~~!!value);
    }

    Awake() {
        super.Awake({
            title: Core.Localizator.Get("gdpr_title"),
        });

        let textColor = 0xc2c2c2;

        this.infoBack = this.content.addChild(new UINineSlice("particles/rect"));
        this.infoBack.tint = 0x000000;
        this.infoBack.alpha = 0.3;

        this.infoText = this.content.addChild(new UIText(Core.Localizator.Get("gdpr_message"), { fill: textColor, wordWrap: true }));
        this.infoPicture = this.content.addChild(new UISprite("creatures/1"));

        this.policyLabel = this.content.addChild(
            new UIText(Core.Localizator.Get("privacy_policy"), {
                align: "right",
                fill: textColor,
            })
        );
        this.policyLabel.anchor.set(1, 0.5);
        this.policyIcon = this.content.addChild(new UISprite("btn-circle-blue"));

        this.termsLabel = this.content.addChild(
            new UIText(Core.Localizator.Get("terms_of_use"), {
                align: "right",
                fill: textColor,
            })
        );
        this.termsLabel.anchor.set(1, 0.5);
        this.termsIcon = this.content.addChild(new UISprite("btn-circle-blue"));

        this.okBtn = this.content.addChild(
            new UINineSliceButton("btn-green", {
                label: Core.Localizator.Get("accept"),
            })
        );
    }

    Init() {
        super.Init();

        this.okBtn.on("pointertap", () => {
            this.shown = true;
            this.Hide();
        });

        // TODO: links
        // this.linkBtn.on("pointertap", () => {
        //     // Application.OpenURL("https://www.aigames.ae/policy");
        // });
    }

    fitLayout(viewport = Core.app.viewport) {
        let sideRatio = 1;
        let w = Math.min(viewport.width * 0.8, (viewport.height * 0.5) / sideRatio);
        let h = w * sideRatio;

        this.setPopupSize(w, h);

        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        rect.height = contentRect.height * 0.25;
        rect.width = contentRect.width;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.3;
        this.infoBack.fitLayout(rect);

        rect = contentRect.clone();
        rect.height = contentRect.width * 0.3;
        rect.width = contentRect.width * 0.3;
        rect.x = (contentRect.width - rect.width) * -0.1;
        rect.y = (contentRect.height - rect.height) * 0.26;
        this.infoPicture.fitRect(rect);

        rect = contentRect.clone();
        rect.height = contentRect.height * 0.23;
        rect.width = contentRect.width * 0.65;
        rect.x = (contentRect.width - rect.width) * 0.75;
        rect.y = (contentRect.height - rect.height) * 0.3;
        this.infoText.fitLayout(rect);

        // TODO: fit link buttons

        let linkRect = contentRect.clone();
        linkRect.height = contentRect.width * 0.1;
        linkRect.width = contentRect.width * 0.45;
        linkRect.x = (contentRect.width - linkRect.width) * 0.5;
        linkRect.y = (contentRect.height - linkRect.height) * 0.55;

        let iconRect = linkRect.clone();
        iconRect.width = linkRect.height * 0.9;
        iconRect.height = linkRect.height * 0.9;
        iconRect.x = linkRect.x + (linkRect.width - iconRect.width) * 1;
        this.policyIcon.fitRect(iconRect);

        let labelRect = linkRect.clone();
        labelRect.width = linkRect.width - linkRect.height;
        labelRect.height = linkRect.height;
        labelRect.x = linkRect.x + (linkRect.width - labelRect.width) * 0;
        this.policyLabel.fitLayout(labelRect);

        linkRect.y = (contentRect.height - linkRect.height) * 0.7;
        iconRect.y = linkRect.y;
        labelRect.y = linkRect.y;
        this.termsIcon.fitRect(iconRect);
        this.termsLabel.fitLayout(labelRect);

        rect = contentRect.clone();
        rect.height = contentRect.height * 0.17;
        rect.width = contentRect.width * 0.45;
        rect.x = (contentRect.width - rect.width) * 0.5;
        rect.y = (contentRect.height - rect.height) * 0.95;
        this.okBtn.fitLayout(rect);
    }

    Trigger() {
        // Comment this to enable GDPR dialog on start
        return this.shown = true;

        if (!this.shown) {
            this.Show();
        }
    }
}
